import React from 'react';
import { CheckIcon } from './icons';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { checkoutUrl, finalBenefits } from '../data/copy';
export function FinalCtaSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="final-cta-heading" data-id="element-60" data-mp="3qukqv5tjh6lq">
      <div className="mx-auto max-w-5xl px-6" data-id="element-61" data-mp="3vsw2nm3e9r6l">
        <div className="text-center" data-id="element-62" data-mp="3vqjjx6ptbcsh">
          <Pill tone="rose" data-id="element-63" data-mp="2y5dry5q6aezy">Your next teaching week</Pill>
          <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-64" data-mp="2y2rbfglb0p5l">
            Your next week of classes is coming either way.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-display text-2xl italic leading-snug text-wine" data-id="element-65" data-mp="38170zf4onqcz">
            This time you don’t have to build every session from zero.
          </p>
        </div>

        <ul className="mx-auto mt-9 grid max-w-4xl gap-3 sm:grid-cols-2" data-id="element-66" data-mp="2fcjmc2efvz8e">
          {finalBenefits.map(benefit => <li key={benefit} className="flex items-start gap-3 rounded-2xl border border-rose-deep/20 bg-blush px-5 py-4" data-id="element-67" data-mp="2dc0davzoth2i">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose-light" aria-hidden="true" data-id="element-68" data-mp="28cdqpvxyyoh1">
                <CheckIcon className="h-3 w-3 text-wine" strokeWidth={2.4} data-id="element-69" data-mp="23km8q9svpr2i" />
              </span>
              <span className="font-sans text-[0.9rem] leading-relaxed text-charcoal/85" data-id="element-70" data-mp="1ymkovmnmpnpz">
                {benefit}
              </span>
            </li>)}
        </ul>

        <div className="mt-10 rounded-4xl border border-gold/35 bg-blush px-7 py-11 text-center sm:px-12" data-id="element-71" data-mp="1pm620iv0o0kd">
          <p className="mx-auto max-w-2xl font-display text-3xl leading-snug text-charcoal" data-id="element-72" data-mp="1kmjftjx7n9zf">
            You bring the experience.
            <span className="mt-3 block text-wine" data-id="element-73" data-mp="1fq2pqk6galjp">
              Ballet Teacher Elite System gives you the structure behind it.
            </span>
          </p>
          <p className="mx-auto mt-5 max-w-readable font-sans text-base leading-relaxed text-ash" data-id="element-74" data-mp="3a210iqkerphp">
            Walk into the studio with your structure, your resources and your
            next steps already within reach. Less searching, less last-minute
            planning, more purposeful teaching.
          </p>
          <CtaButton href={checkoutUrl} size="large" className="mt-8" data-id="element-75" data-mp="yg8ix6u0bodb">
            Get the complete system for $27
          </CtaButton>
        </div>
      </div>
    </section>;
}